import React, { useContext, useEffect, useState } from 'react'
import { CardSwiper } from '../CardSwiper'
import { LeagueContext } from '../../Context'
import { EventBox } from './EventBox/EventBox'
import { isPostseason, setTickerStart } from '../../Utils'
import type { EventGQL } from '../../Api'

type GameTickerProps = {
  hideInPostseason?: boolean
}

export const GameTicker: React.FC<GameTickerProps> = ({hideInPostseason = false}) => {
  const { events } = useContext(LeagueContext)!
  const [boxscores, setBoxscores] = useState<EventGQL[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [startingGame, setStartingGame] = useState<string | null>(null)

  useEffect(() => {
    if(hideInPostseason && isPostseason(events)) {
      setLoading(false)
      return
    }

    if (!boxscores) {
      setStartingGame('0')
      setLoading(false)
      return
    } else {
      setBoxscores(events)
      setStartingGame(`${setTickerStart(events)}`)
      setLoading(false)
    }
  }, [events])

  return (
    <>
      {boxscores.length < 1 || loading ? (
        <div />
      ) : (
        <CardSwiper
          items={boxscores.map((ev) => (
            <EventBox key={ev.id} eventData={ev} />
          ))}
          cardSize="ticker"
          idx={startingGame || '0'}
          showPagination
        />
      )}
    </>
  )
}
